export { default } from './UserDaysStatService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userDaysStat/services/UserDaysStatService/index.js